"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditActionEnum = void 0;
var AuditActionEnum;
(function (AuditActionEnum) {
    AuditActionEnum["Create"] = "Create";
    AuditActionEnum["Update"] = "Update";
    AuditActionEnum["Delete"] = "Delete";
    AuditActionEnum["SoftDelete"] = "SoftDelete";
    AuditActionEnum["Read"] = "Read";
})(AuditActionEnum = exports.AuditActionEnum || (exports.AuditActionEnum = {}));
